import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';
import { mgoAngularWizard } from '../custom';
import { ReverseProductUploadContext } from 'app/reverse-auction-upload-wizard/reverse-auction-upload-wizard.component';

class ReverseUploadWizardPricingAndAuctionSettingsComponentCtrl
    implements ng.IController
{
    private wizardCtrl: mgoAngularWizard.Wizard<ReverseProductUploadContext>;
    public pricingAlgorithms: any = ['UNIFORM_PRICING', 'INDIVIDUAL_PRICING'];
    public possibleRuntimes: any = ['RUNTIME'];
    private possiblePhysicalUnits: [PhysicalUnit | string | string];
    private possibleCurrencies: any;
    public dateTimeNow: any = moment();
    public loadingCurrencies: any = true;
    public loadingCurrenciesError: any = false;
    public today: Date;

    constructor(private StaticData) {
        this.today = new Date();
    }

    $onInit(): void {
        this.StaticData.currenciesForProductUpload(
            (res) => {
                this.possibleCurrencies = res.filter(
                    (item) => item.currencySubunit
                );
                this.loadingCurrencies = false;
                this.loadingCurrenciesError = false;
            },
            () => {
                this.loadingCurrencies = true;
                this.loadingCurrenciesError = true;
            }
        );

        this.possiblePhysicalUnits = [
            this.wizardCtrl.context.data.selectedNetworkPoint.physicalUnit
        ];
    }

    public submit(isValid): boolean {
        if (!isValid) {
            return false;
        }

        this.wizardCtrl.next();
        return true;
    }
}

angular
    .module('app')
    .component('pkpReverseAuctionUploadWizardPricingAndAuctionSettings', {
        controller: ReverseUploadWizardPricingAndAuctionSettingsComponentCtrl,
        template:
            require('app/reverse-auction-upload-wizard/reverse-auction-upload-wizard-pricing-and-auction-settings.component.html'),
        require: {
            wizardCtrl: '^^wizard'
        },
        bindings: {}
    });
